export default { baseUrl: 'https://portal.mtrh.go.ke/' }
